import "core-js/modules/es.object.assign.js";
import { reactive, toRefs } from "vue";
export function useBaseSnackbar() {
  var state = reactive({
    showBaseSnackbar: false,
    baseSnackbarProps: {
      title: "",
      body: "",
      type: "",
      cb: null
    }
  });
  var handleShowSnackbar = function handleShowSnackbar(props) {
    state.baseSnackbarProps.title = props.title || "";
    state.baseSnackbarProps.body = props.body;
    state.baseSnackbarProps.type = props.type;
    state.baseSnackbarProps.cb = props.cb || null;
    state.showBaseSnackbar = true;
  };
  return Object.assign(Object.assign({}, toRefs(state)), {
    handleShowSnackbar: handleShowSnackbar
  });
}